<div class="panneau-tester-lecteur__container">
	<div class="container__content">
		<div class="sce-log-panel">
      <h4>Logs SCE :</h4>
      <div class="sce-log-message" *ngFor="let log of sceLogs">
				<span>- {{ log }}</span>
			</div>
    </div>
		<ng-container *ngIf="demandeCodeCPS">
			<lua-input [fullWidth]="true" type="password" [(ngModel)]="cpsSaisie" placeholder="Code" label="Vous devez saisir le code CPS de la carte" (input)="validateCpsSaisie()"></lua-input>
			<lua-action-secondaire [isDisabled]="!cpsSaisie" libelle="C'est fait !"
				(click)="sendCodeCPS()"></lua-action-secondaire>
		</ng-container>
</div>
